import Card from "../../shared/Card/Card";
import React, { useEffect, useState } from 'react';
import Gauge from "components/charts/Gauge/Gauge";
import { Item } from "types/common";
import { getTagData } from "api/tags";


interface Asas1DCSidebarProps {
    tabs: Array<{ id: string; label: string; content: React.ReactNode }>;
    selectedTab: string;
    setSelectedTab: React.Dispatch<React.SetStateAction<string>>;
}

const Asas1DCSidebar: React.FC<Asas1DCSidebarProps> = ({ tabs, selectedTab, setSelectedTab }) => {
    const [randomTag, setRandomTag] = useState<Item | null>(null);

    const getSingleTag = async () => {
        const randomTagData = await getTagData([244]);
        setRandomTag(randomTagData.data[0]);
    };

    useEffect(() => {
        getSingleTag();
    }, []);
    return (
        <div className="h-[85vh]  overflow-y-auto scrollbar-hidden ">
            <div className="flex justify-between w-full flex-col h-full">

                {randomTag && (
                    <Card title="Room Environment" padding="p-1" className="w-[50%] h-full ">
                        <div className="grid grid-cols-4 gap-2 w-[100%] min-h-0 p-1">
                            <div className="p-2 h-full w-full bg-darkerBlack rounded-md min-h-[32px] 2xl:min-h-[88px] grid place-content-center">
                                <div className="text-[14px] 2xl:text-lg text-green leading-none text-center">37.7 C</div>
                                <p className="text-[14px] whitespace-nowrap
 2xl:text-[16px] font-normal mt-1 text-center">Avg. Temp</p>
                            </div>

                            <div className="p-2 h-full w-full bg-darkerBlack rounded-md min-h-[32px] 2xl:min-h-[88px] grid place-content-center">
                                <div className="text-[14px] 2xl:text-lg text-green leading-none text-center">45.7 %</div>
                                <p className="text-[10px] 2xl:text-[14px] font-normal mt-1 text-center">Avg. Humidity</p>
                            </div>

                            <div className="p-2 h-full w-full bg-darkerBlack rounded-md min-h-[32px] 2xl:min-h-[88px] grid place-content-center">
                                <div className="text-[14px] 2xl:text-lg text-red leading-none text-center">99.3 %</div>
                                <p className="text-[10px] 2xl:text-[14px] font-normal mt-1 text-center">Avg. Airflow</p>
                            </div>

                            <div className="p-2 h-full w-full bg-darkerBlack rounded-md min-h-[32px] 2xl:min-h-[88px] grid place-content-center">
                                <div className="text-[14px] 2xl:text-lg text-yellow leading-none text-center">69.3 %</div>
                                <p className="text-[10px] 2xl:text-[14px] font-normal mt-1 text-center">Air Return</p>
                            </div>


                        </div>
                    </Card>
                )}
                {randomTag && (
                    <div className="mt-2 h-full">
                        <Card title="Power Consumption" padding="p-1" className="w-[50%] h-full ">
                            <div className="flex  justify-between w-[100%] 2xl:max-h-[20vh] min-h-0 pb-2 px-4">
                                <div className="w-[40%] h-[20vh]">
                                    <Gauge
                                        data={randomTag}
                                        gaugeType={"regular"}
                                        name="Total Power Usage"
                                        from="sidebar"

                                    />
                                </div>
                                <div className="w-[40%] h-[20vh]">
                                    <Gauge
                                        data={randomTag}
                                        gaugeType={"regular"}
                                        name="Avg. Power per rack"
                                        from="sidebar"
                                    />
                                </div>
                            </div>
                        </Card>
                    </div>
                )}

                <div className="mt-2 w-full h-full">
                    <Card title="Equipment Composition" padding="p-1">
                        <div className="overflow-x-auto w-full h-full">
                            <table className="w-full text-[11px] text-left border-collapse h-full">
                                <thead>
                                    <tr className="bg-[#082a43] text-white/70">
                                        <th className="px-2 py-1 font-semibold">Type</th>
                                        <th className="px-2 py-1 font-semibold">Total device</th>
                                        <th className="px-2 py-1 font-semibold">Device On</th>
                                        <th className="px-2 py-1 font-semibold">Device Off</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="bg-[#0A3351]">
                                        <td className="px-2 py-1 text-white">Servers</td>
                                        <td className="px-2 py-1 text-blue font-bold">560</td>
                                        <td className="px-2 py-1 text-green font-bold">450</td>
                                        <td className="px-2 py-1 text-red font-bold">110</td>
                                    </tr>
                                    <tr className="bg-[#082a43]">
                                        <td className="px-2 py-1 text-white">Switchers</td>
                                        <td className="px-2 py-1 text-blue font-bold">560</td>
                                        <td className="px-2 py-1 text-green font-bold">450</td>
                                        <td className="px-2 py-1 text-red font-bold">110</td>
                                    </tr>
                                    <tr className="bg-[#0A3351]">
                                        <td className="px-2 py-1 text-white">Routers</td>
                                        <td className="px-2 py-1 text-blue font-bold">560</td>
                                        <td className="px-2 py-1 text-green font-bold">450</td>
                                        <td className="px-2 py-1 text-red font-bold">110</td>
                                    </tr>
                                    <tr className="bg-[#082a43]">
                                        <td className="px-2 py-1 text-white">Firewalls</td>
                                        <td className="px-2 py-1 text-blue font-bold">560</td>
                                        <td className="px-2 py-1 text-green font-bold">450</td>
                                        <td className="px-2 py-1 text-red font-bold">110</td>
                                    </tr>
                                    <tr className="bg-[#0A3351]">
                                        <td className="px-2 py-1 text-white">Network bal.</td>
                                        <td className="px-2 py-1 text-blue font-bold">560</td>
                                        <td className="px-2 py-1 text-green font-bold">450</td>
                                        <td className="px-2 py-1 text-red font-bold">110</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </Card>
                </div>


                <div className="mt-2 w-full h-full">
                    <Card title="Last 4-5 alarms: Composition" padding="p-1">
                        <div className="overflow-x-auto w-full h-full">
                            <table className="w-full text-[11px] text-left border-collapse h-full">
                                <thead>
                                    <tr className="bg-[#082a43] text-white/70">
                                        <th className="px-2 py-1 font-semibold">Source</th>
                                        <th className="px-2 py-1 font-semibold">Time</th>
                                        <th className="px-2 py-1 font-semibold">Message</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="bg-[#0A3351]">
                                        <td className="px-2 py-1 text-white">Sensor-1</td>
                                        <td className="px-2 py-1 text-white/80">10:25 AM</td>
                                        <td className="px-2 py-1 text-white/80">High Temperature</td>
                                    </tr>
                                    <tr className="bg-[#082a43]">
                                        <td className="px-2 py-1 text-white">Sensor-2</td>
                                        <td className="px-2 py-1 text-white/80">10:40 AM</td>
                                        <td className="px-2 py-1 text-white/80">Humidity Alert</td>
                                    </tr>
                                    <tr className="bg-[#0A3351]">
                                        <td className="px-2 py-1 text-white">Sensor-3</td>
                                        <td className="px-2 py-1 text-white/80">11:00 AM</td>
                                        <td className="px-2 py-1 text-white/80">Power Failure</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </Card>
                </div>

            </div>
        </div>
    );
};

export default Asas1DCSidebar;